'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var socket = 'Uninitialized';

var connectWithPolling = function connectWithPolling(_ref) {
  var ioHost = _ref.ioHost,
      token = _ref.token,
      classRooms = _ref.classRooms;
  return _socket2.default.connect(ioHost, {
    query: 'classRooms=' + classRooms,
    transportOptions: {
      polling: {
        extraHeaders: {
          token: token
        }
      }
    },
    rejectUnauthorized: false,
    upgrade: true,
    transports: ['polling', 'websocket'],
    reconnectionDelayMax: 20000 // 20s
  });
};

var connectWithWebSockets = function connectWithWebSockets(_ref2) {
  var ioHost = _ref2.ioHost,
      token = _ref2.token,
      classRooms = _ref2.classRooms;
  return _socket2.default.connect(ioHost, {
    query: 'token=' + token + '&classRooms=' + classRooms,
    transports: ['websocket']
  });
};

/**
 * Make connection to socket server
 * @param {*} ioHost - socket.io host with port and route (localhost:4243/user)
 * @param {*} token - Session token from parse
 * @param {*} classRooms - classRooms (classRoom id's separated by | )
 */
var connect = function connect(ioHost, token, classRooms) {
  var isLocal = process && process.env && process.env.LOCAL;
  socket = isLocal ? connectWithWebSockets({ ioHost: ioHost, token: token, classRooms: classRooms }) : connectWithPolling({ ioHost: ioHost, token: token, classRooms: classRooms });
  return socket;
};

var userIsTyping = function userIsTyping(conversationId) {
  socket.emit('user:typing', conversationId);
};

var sendMessage = function sendMessage(conversationId, message) {
  socket.emit('user:message', conversationId, message);
};

var joinConversation = function joinConversation(conversationId) {
  socket.emit('user:join:conv', conversationId);
};

var joinClass = function joinClass(classId) {
  socket.emit('user:join:class', classId);
};

var subscribeByAccessToken = function subscribeByAccessToken(accessToken) {
  socket.emit('user:subscribeByAccessToken', accessToken);
};

var leaveConversation = function leaveConversation(conversationId) {
  socket.emit('user:leave:conv', conversationId);
};

var leaveClass = function leaveClass(classId) {
  socket.emit('user:leave:class', classId);
};

var unsubscribeSpace = function unsubscribeSpace(spaceId) {
  socket.emit('user:unsubscribeSpace', spaceId);
};

var disconnect = function disconnect() {
  socket.disconnect();
};

exports.default = {
  connect: connect,
  userIsTyping: userIsTyping,
  sendMessage: sendMessage,
  joinConversation: joinConversation,
  joinClass: joinClass,
  subscribeByAccessToken: subscribeByAccessToken,
  leaveConversation: leaveConversation,
  leaveClass: leaveClass,
  unsubscribeSpace: unsubscribeSpace,
  disconnect: disconnect
};